import React, {Component} from "react";
import {getListFromBackendMap} from "../../services/toolsService";

class Table1Header extends Component {
    raiseSort = path => {
        // console.log(
        //     "Table1Header.raiseSort()",
        //     "path",
        //     path,
        //     "this.props.sortColumn",
        //     this.props.sortColumn
        // );
        const sortColumn = {...this.props.sortColumn};
        if (sortColumn.path === path)
            sortColumn.order = sortColumn.order === "asc" ? "desc" : "asc";
        else {
            sortColumn.path = path;
            sortColumn.order = "asc";
        }
        this.props.handleSort(sortColumn);
    };

    renderSortIcon = column => {
        const {sortColumn} = this.props;
        if (!column.path) return null;
        if (column.path !== sortColumn.path) return null;
        if (sortColumn.order === "asc") return <i className="fa fa-sort-asc"></i>;
        return <i className="fa fa-sort-desc"></i>;
    };

    render = () => {
        // console.log("Table1Header.render(): this.props.columns", this.props.columns)
        const {columns, baseInformation} = this.props;

        console.log("getList...()", getListFromBackendMap(baseInformation))
        return (
            <thead>
            <tr>
                {columns.map(column => (
                    <th
                        className="clickable"
                        key={column.path || column.key}
                        onClick={() => this.raiseSort(column.path)}
                    >
                        {column.label} {this.renderSortIcon(column)}
                    </th>
                ))}
                {/*{getListFromBackendMap(baseInformation).map(baseInformationItem => (*/}
                {/*    <th*/}
                {/*        className="clickable"*/}
                {/*        key={baseInformationItem.path || baseInformationItem.key}*/}
                {/*        onClick={() => this.raiseSort(baseInformationItem.path)}*/}
                {/*    >*/}
                {/*        {baseInformationItem.label} {this.renderSortIcon(baseInformationItem)}*/}
                {/*    </th>*/}
                {/*))}*/}
            </tr>
            </thead>
        );
    }
}

export default Table1Header;
